import * as React from 'react'

export const ArrowIcon = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2931 18.7043C13.9026 18.3137 13.9026 17.6806 14.2931 17.2901L18.5861 12.9971H3C2.44772 12.9971 2 12.5494 2 11.9971C2 11.4448 2.44772 10.9971 3 10.9971H18.5861L14.2931 6.70418C13.9026 6.31365 13.9026 5.68049 14.2931 5.28996C14.6837 4.89944 15.3168 4.89944 15.7073 5.28996L21.7003 11.2829C21.7064 11.289 21.7123 11.2951 21.7182 11.3013C21.8926 11.4813 22 11.7267 22 11.9971C22 12.2663 21.8936 12.5107 21.7205 12.6905C21.7156 12.6958 21.7105 12.701 21.7054 12.7061L21.7029 12.7087L21.7003 12.7113L15.7074 18.7043C15.3168 19.0948 14.6837 19.0948 14.2931 18.7043Z"
        fill="#0070E0"
      />
    </svg>
  )
})

ArrowIcon.displayName = 'ArrowIcon'
